module.exports = __webpack_public_path__ + "static/media/background-2.acea6839.jpg";